<template>
    <div class="input-group col-sm-3 float-right">
        <div class="input-group-addon fa fa-search" style="display:table-cell"></div>
        <input class="form-control fa fa-search" name="query" v-model="searchQuery">
    </div>
</template>

<script>
    export default {
        name: "searchInputTemplate",
        props: {
            
        },
        data() {
            return {
                searchString: '',
                templateArgs: {},
            };
        },
        mounted() {
            var container = $(this.$el);
            container.find('[data-toggle="tooltip"]').tooltip({container});
        },
        methods: {
            
        }
    };
</script>
